import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../Footer'
import axios from 'axios'
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BtnLoader } from '../components/PageLoader';


const Register = () => {
  const optionToast = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [errors, setErrors] = useState({});
  const [processing, setProcessing] = useState(false);
  const navigator = useNavigate();

  useEffect(() => {
    if (!showOtpInput || otpCountdown <= 0) {
      if (showOtpInput && otpCountdown === 0) {
        setCanResendOtp(true);
      }
      return;
    }

    const timer = setInterval(() => {
      setOtpCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [showOtpInput, otpCountdown]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const togglePasswordVisibility = () => {

    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityConfirm = () => {

    setShowPasswordConfirm(!showPasswordConfirm);
  };

  const validate = () => {
    const newErrors = {};

    if (!firstName.match(/^[A-Za-z]+$/)) {
      newErrors.firstName = "First name must contain only letters";
    }

    if (!email.match(/^\S+@\S+\.\S+$/)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (!phone) {
      newErrors.phone = "Mobile number is required";
    } else if (!phone.match(/^\+?\d{10,15}$/)) {
      newErrors.phone = "Enter a valid phone number (10-15 digits, optional '+').";
    }

    if (!acceptTerms) {
      newErrors.acceptTerms = "You must accept the terms to continue.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSignUp = () => {
    // Validate all fields
    setProcessing(true);
    var isValidate = validate();
    if (!isValidate) {
      // If any field is empty, show an error
      toast.error("All fields are required", optionToast);
      setProcessing(false);
      return;
    }

    // Check if the password and confirmPassword match
    if (password !== confirmPassword) {
      toast.error("Password does not match the confirmation password", optionToast);
      setProcessing(false);
      return;
    }


    if (!showOtpInput) {
      sendOtpData();
    } else {
      verifyOtpAndRegister();
    }
  };

  const sendOtpData = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/auth/send-email-otp",
        {
          email: email,
          first_name: firstName,
          last_name: lastName,
          mobile: phone,
          purpose: "registration",
        }
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message || "OTP sent successfully", optionToast);
        setShowOtpInput(true);
        setOtpCountdown(300);
        setCanResendOtp(false);
      } else {
        toast.error(response?.data?.message, optionToast);
      }
    } catch (error) {
      const backendErrors = error?.response?.data?.errors;
      const firstBackendError = backendErrors
        ? Object.values(backendErrors).flat().find(Boolean)
        : null;
      toast.error(firstBackendError || error?.response?.data?.message || "Unable to send OTP", optionToast);
    }
    setProcessing(false);
  };

  const verifyOtpAndRegister = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(window.CARLOCA_API + "/auth/verify-email-otp", {
        email,
        otp,
        purpose: "registration",
      });

      if (!response?.data?.success) {
        toast.error(response?.data?.message || "OTP verification failed", optionToast);
        setProcessing(false);
        return;
      }

      await saveData();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Invalid OTP", optionToast);
      setProcessing(false);
    }
  };

  const resendOtp = async () => {
    if (!canResendOtp) {
      return;
    }

    await sendOtpData();
  };
  const saveDataTolocalStorage = (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  };
  const saveData = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/auth/register",
        {
          email: email,
          mobile: phone,
          password: password,
          password_confirmation: confirmPassword,
          first_name: firstName,
          last_name: lastName,
          accept_terms: true,
        }
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message, optionToast);
        const newUserData = { ...(response?.data?.data?.user || {}) };
        if (response?.data?.data?.token) {
          newUserData.token = response?.data?.data?.token;
        }
        saveDataTolocalStorage("userData", newUserData);
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setPassword('');
        setConfirmPassword('');
        setOtp('');
        setShowOtpInput(false);
        setOtpCountdown(0);
        setCanResendOtp(false);
        setAcceptTerms(false);
        setTimeout(() => {
          navigator('/profilesetting');
        }, 1500);
      } else {
        toast.error(response?.data?.message, optionToast);
      }


    } catch (error) {
      toast.error(error?.response?.data?.message || "Registration failed", optionToast);
    }
    setProcessing(false);
  };


  return (
    <>
      <Navbar />
      <div className="cl-auth-page" style={{ paddingTop: 78 }}>
        <div className="cl-auth-card" style={{ maxWidth: 500 }}>
          <div className="text-center mb-3">
            <img src="/img/Logo_trusted_Cars.png" alt="Trusted Cars" style={{ height: 44, marginBottom: 10 }} />
          </div>
          <h5 className="cl-auth-title">Create Your Account</h5>
          <p className="cl-auth-subtitle">Enter your details below to get started</p>

          <form method="post" className="w-100" onSubmit={(e) => { e.preventDefault(); handleSignUp(); }}>
            <div className="row">
              <div className="col-6 mb-3">
                <label className="cl-form-label">First Name*</label>
                <input type="text" placeholder="John"
                  className={`cl-form-control ${errors.firstName ? 'border-danger' : ''}`}
                  value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
              </div>
              <div className="col-6 mb-3">
                <label className="cl-form-label">Last Name*</label>
                <input type="text" placeholder="Doe" className="cl-form-control"
                  value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Email*</label>
              <div className="position-relative">
                <input type="email" placeholder="you@email.com"
                  className={`cl-form-control ${errors.email ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38 }}
                  value={email} onChange={(e) => setEmail(e.target.value)} />
                <i className="fa-solid fa-envelope" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
              </div>
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Phone*</label>
              <div className="position-relative">
                <input type="tel" placeholder="+44 7700 900000"
                  className={`cl-form-control ${errors.phone ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38 }}
                  value={phone} onChange={(e) => setPhone(e.target.value)} />
                <i className="fa-solid fa-phone" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
              </div>
              {errors.phone && <small className="text-danger">{errors.phone}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Password*</label>
              <div className="position-relative">
                <input type={showPassword ? 'text' : 'password'} placeholder="***************"
                  className={`cl-form-control ${errors.password ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38, paddingRight: 40 }}
                  value={password} onChange={(e) => setPassword(e.target.value)} />
                <i className="fa-solid fa-lock" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
                <div style={{ position: 'absolute', top: '50%', right: 12, transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={togglePasswordVisibility}>
                  <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} style={{ color: '#b0bac5', fontSize: 14 }}></i>
                </div>
              </div>
              {errors.password && <small className="text-danger">{errors.password}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Confirm Password*</label>
              <div className="position-relative">
                <input type={showPasswordConfirm ? 'text' : 'password'} placeholder="***************"
                  className={`cl-form-control ${errors.confirmPassword ? 'border-danger' : ''}`}
                  style={{ paddingLeft: 38, paddingRight: 40 }}
                  value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                <i className="fa-solid fa-lock" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
                <div style={{ position: 'absolute', top: '50%', right: 12, transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={togglePasswordVisibilityConfirm}>
                  <i className={`fa-solid ${showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'}`} style={{ color: '#b0bac5', fontSize: 14 }}></i>
                </div>
              </div>
              {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
            </div>
            {showOtpInput && (
              <div className="mb-3">
                <label className="cl-form-label">OTP Code*</label>
                <div className="position-relative">
                  <input type="text" placeholder="Enter OTP" className="cl-form-control" style={{ paddingLeft: 38 }}
                    value={otp} onChange={(e) => setOtp(e.target.value)} />
                  <i className="fa-solid fa-key" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#b0bac5', fontSize: 14 }}></i>
                </div>
                <small className="text-muted d-block mt-1">Check your junk/spam folder if you don't see the email.</small>
                <div className="mt-1">
                  {otpCountdown > 0 ? (
                    <small className="text-muted">Resend OTP in {formatTime(otpCountdown)}</small>
                  ) : (
                    <small className="text-decoration-none fw-semibold" style={{ color: "#00889c", cursor: "pointer" }} onClick={resendOtp}>
                      Resend OTP
                    </small>
                  )}
                </div>
              </div>
            )}
            <div className="mb-3 form-check">
              <input
                id="acceptTerms"
                type="checkbox"
                className="form-check-input"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
              />
              <label htmlFor="acceptTerms" className="form-check-label">
                I accept the Terms and Conditions
              </label>
              {errors.acceptTerms && <small className="text-danger d-block">{errors.acceptTerms}</small>}
            </div>
            <button type="submit" disabled={processing} className="cl-btn cl-btn-primary cl-btn-lg w-100">
              {processing ? <><BtnLoader />{!showOtpInput ? 'Sending OTP...' : 'Verifying...'}</> : (!showOtpInput ? 'Send OTP' : 'Verify OTP & Register')}
            </button>
            <div className="cl-auth-divider mt-3">Already have an account?</div>
            <Link to="/login" className="cl-btn cl-btn-outline cl-btn-lg w-100">Sign In</Link>
          </form>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  )
}

export default Register
